// extracted by mini-css-extract-plugin
export default {"container":"Choice_container__21CS-","option":"Choice_option__qs7WD"};